import { estimatedColumnWidth } from "../helpers";
import { formatCurrency, formatDate } from "@/utils/helpers";

const textFormatter = (value) => String(value || "");
const amountFormatter = (value) => (value ? formatCurrency(String(value || "")) : "");
const dateFormatter = (value) => (value ? formatDate(new Date(value)) : "");

const column = (label, columnId, widthType, formatter = textFormatter) => ({
  label,
  value: true,
  columnId,
  width: estimatedColumnWidth(widthType),
  resizable: true,
  formatter,
});

// Same order as the export (CustomerAgingReport.Columns).
// Keys are the API columns camelized by humps, so PDCNumber arrives as pDCNumber.
export default function getAgingColumns() {
  return [
    column("Component Number", "componentNumber", "number"),
    column("Component Name", "componentName", "name"),
    column("Tenant Number", "tenantNumber", "number"),
    column("Tenant Name", "tenantName", "name"),
    column("Contract", "contract", "name"),
    column("Status", "status", "number"),
    column("Invoice Number", "invoiceNumber", "number"),
    column("Transaction Date", "transactionDate", "date", dateFormatter),
    column("Invoice Type", "invoiceType", "number"),
    column("Installments", "installments", "number"),
    column("Amount", "amount", "amount", amountFormatter),
    column("Paid", "paid", "amount", amountFormatter),
    column("Balance", "balance", "amount", amountFormatter),
    column("0-30 Days", "oneMonth", "amount", amountFormatter),
    column("31-60 Days", "twoMonth", "amount", amountFormatter),
    column("61-90 Days", "threeMonth", "amount", amountFormatter),
    column("91-121 Days", "over91Days", "amount", amountFormatter),
    column("122-365 Days", "over122Days", "amount", amountFormatter),
    column("Above 365 Days", "over365Days", "amount", amountFormatter),
    column("PDC Number", "pDCNumber", "number"),
    column("Cheque Number", "chequeNumber", "number"),
    column("PDC Amount", "pDCAmount", "amount", amountFormatter),
  ];
}
